import { OpenSubscribeDecideDialogResult } from './15.dialogs';

export default defineNuxtPlugin(() => {
  const { $subscription, $globals, $dialogs, $api, $game, $router } =
    useNuxtApp();

  const { purchase } = usePurchase();
  const route = useRoute();
  let query: { [key: string]: string } = {};
  const purchaseSubTypeIds = ref<string | null>(null);

  const isReadyToShowSubFeedback = computed(
    () =>
      $subscription.isUserSubsReady &&
      $globals.images &&
      Object.values($globals.images).length &&
      (route.query.status ||
        route.query.error ||
        route.query.subTypeId ||
        (route.query.articleId && route.query.purchaseType)),
  );

  const showSubscriptionDialog = async () => {
    if (!Object.keys(query).length) {
      initRoutQuery();
    }
    if (isInSufficientFunds()) {
      $dialogs.startSubscriptionDialog(+query.type, 2);
    } else if (isSuccessRedirect()) {
      // add logic for purchase
      if (query.purchaseID && query.purchaseType === 'music') {
        $dialogs.articleId = query.purchaseID as string;

        $subscription.downloadArticle(
          { id: query.articleId || query.purchaseID },
          false,
        );
        $dialogs.openPurchasedPopup();
        cleanDialogsProperties();
      } else if (
        (query.purchaseID || query.articleId) &&
        (query.purchaseType === 'ONLINE_GAME' ||
          query.purchaseType === 'CLOUD_GAME')
      ) {
        const { articleId, purchaseID } = { ...query };
        $game.play(
          null,
          articleId || purchaseID,
          null,
          null,
          null,
          'portal_list',
        );
        cleanRoutQuery(['articleId', 'purchaseID', 'purchaseType']);
        cleanDialogsProperties();
      }
      if (
        (query.purchaseID || query.articleId) &&
        query.purchaseType === 'GAME'
      ) {
        $game.download(
          null,
          query.articleId || query.purchaseID,
          null,
          'portal_list',
        );
        cleanDialogsProperties();
      }
      if (
        !purchaseSubTypeIds.value &&
        !$dialogs.purchasePopToggle &&
        query.type
      ) {
        $dialogs.startSubscriptionDialog(query.type, 1);
      } else if (query.articleId && query.purchaseType === 'CHALLENGE') {
        //$gamification.handleChallengePopInfo(query.articleId);
        cleanRoutQuery(['articleId', 'purchaseType']);
        cleanDialogsProperties();
      }
    } else if (isUserAlreadySubscribed()) {
      $dialogs.startSubscriptionDialog(query.type, 3);
    } else if (query.type) {
      let statusNumber = query.status == '202' ? 6 : 4;
      $dialogs.startSubscriptionDialog(
        query.type,
        statusNumber,
        query.status,
        query.i18Message,
      );
    }
    cleanRoutQuery(['status', 'type', 'i18Message', 'msg', 'mpay_error']);
  };
  const handlePurchasing =
    async (): Promise<void | OpenSubscribeDecideDialogResult> => {
      if (process.client) {
        if (!$dialogs.articleId) $dialogs.articleId = query.articleId;
        if (!$dialogs.purchaseType) $dialogs.purchaseType = query.purchaseType;
        if (query.purchaseType === 'music') {
          await musicPurchaseFlow();
        } else {
          if (query.subTypeId) {
            await $dialogs.showUserPurchaseOptionsDialog(query.subTypeId);
          } else {
            await $dialogs.showUserPurchaseOptionsDialog(
              purchaseSubTypeIds.value,
            );
          }
        }
      }
    };
  const initRoutQuery = () => {
    query = Object.assign({}, route.query);
  };
  const cleanRoutQuery = async (deletedRoutKey?: string | string[]) => {
    if (deletedRoutKey) {
      if (typeof deletedRoutKey === 'string') {
        delete query[deletedRoutKey];
      } else if (Array.isArray(deletedRoutKey)) {
        deletedRoutKey.forEach((key) => {
          delete query[key];
        });
      }
    } else {
      Object.keys(query).forEach((key) => delete query[key]);
    }
    await $router.replace({ query }).catch(() => {});
  };
  const isSuccessRedirect = () => {
    return (
      query.status === '200' ||
      query.status === 'success' ||
      query.msg == 'OK' ||
      query.msg == 'success' ||
      (query.articleId && query.purchaseType)
    );
  };
  const isInSufficientFunds = () => {
    return (
      query.status === '402' ||
      query.error === 'INSUFFICIENT_FUNDS' ||
      (query.msg === 'INSUFFICIENT_FUNDS' && query.type)
    );
  };
  const isUserAlreadySubscribed = () => {
    return (
      query.status === '409' ||
      query.status === '409 CONFLICT' ||
      query.error == 'USER_ALREADY_SUBSCRIBED' ||
      (query.msg === 'USER_ALREADY_SUBSCRIBED' && query.type)
    );
  };

  const musicPurchaseFlow = async () => {
    let inwallet;
    try {
      const res = await $api.endPoints.getUserWallet(query.articleId);
      inwallet = res.data;

      if (inwallet && inwallet.articleId) {
        await cleanRoutQuery();
        return;
      }
    } catch (error) {
      // error calling get wallet
      console.error('Failed to get wallet');
    }
    try {
      const articleDetails = await $api.endPoints.getStructure(
        `fragments_get-article-details`,
        {
          id: query.articleId || query.purchaseID,
        },
      );
      // we need to check the state of the redirect .. is it purchased yet or not
      await purchase(articleDetails[0].data);
    } catch (error) {
      // skip error
    }
  };
  const cleanDialogsProperties = () => {
    $dialogs.articleId = '';
    $dialogs.purchaseID = '';
    $dialogs.purchaseType = '';
  };
  const getUserPurchaseOptions = async () => {
    await $api.endPoints.getDeviceInfo();
    if (!query?.articleId) return;
    if (purchaseSubTypeIds.value) return purchaseSubTypeIds.value;
    try {
      let res = await $api.endPoints.getUserPurchaseOptions(
        query?.articleId,
        query?.purchaseType,
        $api.endPoints.deviceId,
      );
      purchaseSubTypeIds.value = typeof res === 'string' ? res : null;
      if (!purchaseSubTypeIds.value) {
        return;
      }
      return purchaseSubTypeIds.value;
    } catch (error) {
      // skip error
      // console.info(error);
    }
  };
  if (import.meta.client) {
    watch(
      isReadyToShowSubFeedback,
      async () => {
        if (isReadyToShowSubFeedback.value) {
          initRoutQuery();
          // await getUserPurchaseOptions();
          if (!route.query.type) {
            const handlePurchasingResult = await handlePurchasing();
            if (
              handlePurchasingResult ===
                OpenSubscribeDecideDialogResult.LOGIN ||
              handlePurchasingResult ===
                OpenSubscribeDecideDialogResult.REDIRECT
            ) {
              return;
            }
          }
          if (query.status === 'SUCCESS') {
            $subscription.downloadArticle({ id: $dialogs.articleId }, false);
            $dialogs.openPurchasedPopup();
            cleanRoutQuery(['status', 'type']);
          }
          if (query.error === 'INSUFFICIENT_FUNDS') {
            $dialogs.openSubscriptionFeedbackDialog(2, '', '', true);
            cleanRoutQuery('error');
          }
          if (
            route.query?.error == 'NO_SUBSCRIPTION_FOUND' &&
            route.query?.status == '404'
          ) {
            $dialogs.loginSubscriptionErrorDialog = true;
            cleanRoutQuery(['error', 'message', 'status']);
          } else {
            showSubscriptionDialog();
          }
        }
      },
      {
        immediate: true,
      },
    );
    watch(
      () => route.query,
      async () => {
        if (
          typeof window !== 'undefined' &&
          (route.query?.utm_campaign ||
            route.query?.clickId ||
            route.query?.['utm_source'])
        ) {
          const { agency, clickId, utm_medium, utm_source, utm_campaign } =
            route.query;
          let marketingCampaign = {
            agency: agency,
            conversionId: clickId,
            medium: utm_medium,
            name: utm_campaign,
            source: utm_source,
            campaignId: `${utm_source}-[${utm_campaign}]-[${utm_medium}]`,
          };
          sessionStorage.setItem(
            'marketingCampaign',
            JSON.stringify(marketingCampaign),
          );
          // cleanRoutQuery([
          //   'agency',
          //   'clickId',
          //   'utm_medium',
          //   'utm_source',
          //   'utm_campaign',
          // ]);
        }
      },
      {
        immediate: true,
      },
    );
  }
});
